'use client';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  transform-origin: left center;
  height: ${({ $height }) => `${$height}px`};
  width: ${({ $isExpanded, $width, $expandedWidth }) =>
    $isExpanded
      ? $expandedWidth
        ? `${$expandedWidth}px`
        : '100%'
      : `${$width}px`};
  max-width: 100%;
  border-radius: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.colors.background.lightest};
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
  transition: width 320ms ease-in-out;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing(4)};
  right: ${({ theme }) => theme.spacing(4)};
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
`;
